module.exports = __webpack_public_path__ + "img/sombrero-de-graduacion.2764632a.svg";